import { render, staticRenderFns } from "./targetSelection.vue?vue&type=template&id=531d48f3&scoped=true&"
import script from "./targetSelection.vue?vue&type=script&lang=js&"
export * from "./targetSelection.vue?vue&type=script&lang=js&"
import style0 from "./targetSelection.vue?vue&type=style&index=0&id=531d48f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531d48f3",
  null
  
)

export default component.exports